export enum AF_ACTION {
  UPGRADE_DECLINED_MEMBERSHIP = 'UPGRADE_DECLINED_MEMBERSHIP',
  SEND_PAYMENT_PORTAL_LINK = 'SEND_PAYMENT_PORTAL_LINK',
}

export interface AfActionsPayload {
  action: AF_ACTION;
  context?: { email: string };
}
